import { useState } from 'react';
import { Helmet } from 'react-helmet';
import * as S from './Policy.styles';

const Policy = () => {
  const [lang, setLang] = useState('zh');

  return (
    <S.Container>
      <Helmet>
        <title>Uplus Education - Policy</title>
        <meta name="description" content="Uplus Education absence, make-up, credit and withdrawal/refund policy." />
      </Helmet>

      <S.Title>
        {lang === 'zh' ? '学生请假、补课、Credit 与退课退款政策' : 'Absence, Make-up, Credit & Withdrawal/Refund Policy'}
      </S.Title>
      <S.SubTitle>
        {lang === 'zh' ? '(Absence, Make-up, Credit & Withdrawal/Refund Policy)' : ''}
      </S.SubTitle>

      <S.LanguageToggle>
        <S.LangButton $active={lang === 'zh'} onClick={() => setLang('zh')}>中文</S.LangButton>
        <S.LangButton $active={lang === 'en'} onClick={() => setLang('en')}>English</S.LangButton>
      </S.LanguageToggle>

      <S.Meta>
        <p>{lang === 'zh'
          ? '适用对象：Uplus Education（Claremont）所有课程（小组课、1 对 1、1 对 2/3）。'
          : 'Applicable to: All Uplus Education (Claremont) courses (group, 1-to-1, 1-to-2/3).'}</p>
        <p>{lang === 'zh'
          ? '本政策旨在保障教学秩序与公平性，同时保持排课与师资安排的可持续性。'
          : 'This policy aims to maintain teaching order and fairness, while ensuring the sustainability of scheduling and staffing.'}</p>
        <p>{lang === 'zh'
          ? '收费周期说明：本中心按 Term（10 周）收费与结算。'
          : 'Billing cycle: The centre charges and settles on a per-Term (10-week) basis.'}</p>
      </S.Meta>

      <S.Disclaimer>
        {lang === 'zh'
          ? '重要声明：本政策不排除或限制您在《Australian Consumer Law（澳大利亚消费者法）》下的任何权利。'
          : 'Important: This policy does not exclude or limit any rights you may have under the Australian Consumer Law.'}
      </S.Disclaimer>

      {lang === 'zh' ? <ChineseContent /> : <EnglishContent />}

      <S.Footer>
        Uplus Education &copy; {new Date().getFullYear()}
      </S.Footer>
    </S.Container>
  );
};

const ChineseContent = () => (
  <>
    {/* Section A */}
    <S.Section>
      <S.SectionTitle>A. 请假与补课</S.SectionTitle>

      <S.SubSection>
        <S.SubSectionTitle>1) 请假通知要求</S.SubSectionTitle>
        <S.Text>请假需至少提前 24 小时通知（短信/微信/电话均可，以中心收到为准）。</S.Text>
        <S.Text>未满 24 小时的临时请假或无故缺席，课程视为已完成，不安排补课或 Credit。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>2) 同课程调班（不计入补偿次数）</S.SubSectionTitle>
        <S.Text>可调至同年级、同科目、同课程内容的其他班级（视名额而定）。</S.Text>
        <S.Text>该类调班属于"同课程调班"，不占用本政策所述的补偿/Credit 次数。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>3) 无相同课程可调时的补偿方式（每 Term（10 周）仅限 1 次）</S.SubSectionTitle>
        <S.Text>若中心在合理时间内无法提供同课程调班名额，学生可在以下两种方式中二选一（每 Term（10 周）最多 1 次/每位学生）：</S.Text>
        <S.OptionBox>
          <S.BoldText><S.OptionLabel>方案一：</S.OptionLabel>替代性补课（按原课程类型折算 1 对 1 时长）</S.BoldText>
          <S.IndentBlock>
            <S.Text>原为 1 对 2 / 1 对 3：可补 1 对 1，时长为原课时的 1/2。</S.Text>
            <S.Text>原为多人小组课：可补 1 对 1，时长为原课时的 1/4。</S.Text>
          </S.IndentBlock>
        </S.OptionBox>
        <S.OptionBox>
          <S.BoldText><S.OptionLabel>方案二：</S.OptionLabel>转换为 Credit（金额 Credit，不是课时 Credit）</S.BoldText>
        </S.OptionBox>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>4) Credit 规则（金额制）</S.SubSectionTitle>
        <S.Text>Credit 仅按"金额"记录与使用，不转换为固定课时数。</S.Text>
        <S.Text>Credit 计算不包含任何优惠：若原订单含十周报名/全勤等折扣，Credit/退款将按"原价（标准单次课费）"重新核算。</S.Text>
        <S.Text>Credit 仅可用于抵扣后续学费，不能兑换现金、不能转让（同一家庭兄弟姐妹可在中心书面同意后共享）。</S.Text>
        <S.Text>Credit 有效期：自生成之日起 2 个 Term（10 周）内使用；如因中心排课原因无法在有效期内安排使用，中心可酌情顺延。</S.Text>
        <S.Text>若未来学费标准调整，Credit 将按余额金额抵扣对应费用，可能对应课时数不同。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>5) 预约与使用</S.SubSectionTitle>
        <S.Text>所有补课/调班/使用 Credit 均需提前预约，视师资与班级名额安排。</S.Text>
        <S.Text>同一节课仅可补偿一次；已安排的补课如再次缺席，按缺席处理。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>6) 教材与学习资料（可选）</S.SubSectionTitle>
        <S.Text>课堂教材/练习讲义一般在课堂发放，已包含在正常上课费用中（学生正常上课或参加补课时可领取）。</S.Text>
        <S.Text>如学生请假缺席但不申请将该节课转换为 Credit，家长可在中心安排下免费领取该节课教材用于内容衔接（以中心可提供的资料为准）。</S.Text>
        <S.Text>若学生缺席并选择将该节课转换为金额 Credit（即不安排补课/调班），该节课教材不自动包含；如仍希望领取该节课教材用于内容衔接，可购买"单节课教材包" AU$10/份（含打印与整理成本）。教材一经提供，教材费用不退。</S.Text>
        <S.Text>如学生未报名该节课/中途加入课程，也可按 AU$10/份购买相应教材包（以中心可提供的资料为准）。</S.Text>
        <S.Text>如因中心原因取消课程，中心将免费提供相应教材或安排补课/金额 Credit（不额外收取教材费）。</S.Text>
      </S.SubSection>
    </S.Section>

    {/* Section B */}
    <S.Section>
      <S.SectionTitle>B. 退课与退款</S.SectionTitle>

      <S.SubSection>
        <S.SubSectionTitle>1) 退课申请方式</S.SubSectionTitle>
        <S.Text>退课需由家长/监护人以书面形式提出（短信/微信/邮件均可），并注明学生姓名、课程、退课原因与期望生效日期。</S.Text>
        <S.Text>为减少不必要的损失并便于安排师资，建议尽量提前至少 3 天通知中心。</S.Text>
        <S.Text>退款将原路退回至原支付方式（或双方同意的方式），一般在 7 个工作日内处理完成。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>2) 退款计算方式（不享受任何折扣）</S.SubSectionTitle>
        <S.Text>如课程已开始，退款/余额将按以下顺序计算：</S.Text>
        <S.IndentBlock>
          <S.BoldText>已上课费用：</S.BoldText>
          <S.Text>按中心当期公布的标准单次课费（原价）计算，不使用任何折扣价。</S.Text>
        </S.IndentBlock>
        <S.IndentBlock>
          <S.BoldText>行政费用（Admin fee）：</S.BoldText>
          <S.Text>扣除一次性管理费用，用于排课、沟通、教材与资源准备等管理成本。管理费用按"1 节课原价"计算，最高不超过 AU$95（每次退课仅收取一次）。</S.Text>
        </S.IndentBlock>
        <S.IndentBlock>
          <S.BoldText>余额：</S.BoldText>
          <S.Text>已支付金额减去上述费用后的剩余金额。余额可选择"退回"或"转为金额 Credit"（二选一）。</S.Text>
        </S.IndentBlock>
        <S.Text style={{ marginTop: '0.5rem', fontStyle: 'italic', color: '#666' }}>备注：若按原价核算后余额为 0 或为负，则不产生退款或 Credit。</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>3) 例外与消费者法</S.SubSectionTitle>
        <S.Text>如出现服务重大问题（major failure）或中心未能按约提供服务，您可能在澳大利亚消费者法下享有取消并获得退款等权利，本政策不影响该等权利。</S.Text>
        <S.Text>如遇特殊情况（如重大疾病、家庭紧急情况），中心可在提供证明材料后酌情处理。</S.Text>
      </S.SubSection>
    </S.Section>

    {/* Appendix */}
    <S.Section>
      <S.SectionTitle>附录：计算示例（仅供参考）</S.SectionTitle>
      <S.ExampleBox>
        <S.ExampleTitle>示例 1：退课退款</S.ExampleTitle>
        <p>Term 套餐已付 AU$722（折扣价），上了 6 节课后退课。标准单次课费 AU$76。</p>
        <p>余额 = 722 - (6×76) - 管理费 76 = <strong>AU$190</strong>（可退款或转为 Credit）。</p>
      </S.ExampleBox>
      <S.ExampleBox>
        <S.ExampleTitle>示例 2：请假转 Credit</S.ExampleTitle>
        <p>提前 24 小时请假 1 节课并选择 Credit。Term 套餐已付 AU$722（折扣价）。标准单次课费 AU$76。</p>
        <p>Credit = 722 - (9×76) = <strong>AU$38</strong>（金额制）。</p>
      </S.ExampleBox>
    </S.Section>
  </>
);

const EnglishContent = () => (
  <>
    {/* Section C - English */}
    <S.Section>
      <S.SectionTitle>A. Absence & Make-up</S.SectionTitle>

      <S.SubSection>
        <S.SubSectionTitle>1) Notice requirement</S.SubSectionTitle>
        <S.Text>Absences must be notified at least 24 hours in advance to be eligible for make-up or credit.</S.Text>
        <S.Text>Late notice (&lt;24 hours) or no-show lessons are forfeited and treated as delivered.</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>2) Same-course transfer (not counted as a make-up/credit)</S.SubSectionTitle>
        <S.Text>Students may attend another class of the same year level, subject and lesson content, subject to availability.</S.Text>
        <S.Text>This option does not count toward the make-up/credit limit.</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>3) If no equivalent class is available (max 1 time per term, per student)</S.SubSectionTitle>
        <S.OptionBox>
          <S.BoldText><S.OptionLabel>Option A: </S.OptionLabel>Alternative arrangement (converted to 1-to-1 time)</S.BoldText>
          <S.IndentBlock>
            <S.Text>1-to-2/1-to-3 lessons: eligible for a 1-to-1 session at half the original duration.</S.Text>
            <S.Text>Group lessons: eligible for a 1-to-1 session at one-quarter of the original duration.</S.Text>
          </S.IndentBlock>
        </S.OptionBox>
        <S.OptionBox>
          <S.BoldText><S.OptionLabel>Option B: </S.OptionLabel>Credit (value-based, not time-based)</S.BoldText>
        </S.OptionBox>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>4) Credit rules (value-based)</S.SubSectionTitle>
        <S.Text>Credits are stored and redeemed as a dollar value only (not a fixed number of hours).</S.Text>
        <S.Text>Credits/refunds are calculated at the standard casual rate (full price). Any package/term discounts do not apply.</S.Text>
        <S.Text>Credits are non-transferable, non-cash, and can be used to offset future tuition fees.</S.Text>
        <S.Text>Credit expiry: 2 terms from the date of issue. If a credit cannot be used due to centre scheduling constraints, the centre may extend the validity.</S.Text>
        <S.Text>If fees change in future, the credit will offset the amount payable and may represent a different number of lessons.</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>5) Learning materials (optional)</S.SubSectionTitle>
        <S.Text>Lesson materials/handouts are normally provided in class and are included in the standard tuition fee (when the student attends the scheduled class or make-up session).</S.Text>
        <S.Text>If a student is absent but the family does not request value-based credit for that lesson, the family may collect the lesson materials from the centre (subject to availability).</S.Text>
        <S.Text>If a family chooses value-based credit for a missed lesson (i.e., no make-up/transfer is arranged) and still wishes to receive the lesson materials for continuity, a AU$10 per-lesson materials pack fee applies (printing/handling). Once supplied, materials fees are non-refundable.</S.Text>
        <S.Text>Families may also purchase a materials pack for lessons/weeks they are not enrolled in, subject to availability.</S.Text>
        <S.Text>If a lesson is cancelled by the centre, the centre will provide materials or an alternative arrangement at no additional materials charge.</S.Text>
      </S.SubSection>
    </S.Section>

    {/* Section B - Withdrawal & Refund */}
    <S.Section>
      <S.SectionTitle>B. Withdrawal & Refund</S.SectionTitle>

      <S.SubSection>
        <S.SubSectionTitle>1) Withdrawal request</S.SubSectionTitle>
        <S.Text>Withdrawal requests must be made in writing by a parent/guardian.</S.Text>
        <S.Text>To help minimise disruption and allow staff scheduling, we recommend providing at least 3 days' notice where possible.</S.Text>
        <S.Text>Refunds are processed back to the original payment method, typically within 7 business days.</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>2) Refund calculation (no discounts)</S.SubSectionTitle>
        <S.Text>If lessons have commenced, the refund/balance is calculated as follows:</S.Text>
        <S.IndentBlock>
          <S.BoldText>Lessons delivered:</S.BoldText>
          <S.Text>Charged at the standard casual rate (full price), no discounts applied.</S.Text>
        </S.IndentBlock>
        <S.IndentBlock>
          <S.BoldText>Administration fee:</S.BoldText>
          <S.Text>A one-off admin fee for scheduling, communication, materials and resource preparation. Calculated as 1 lesson at the standard casual rate, capped at AU$95 (charged once per withdrawal).</S.Text>
        </S.IndentBlock>
        <S.IndentBlock>
          <S.BoldText>Balance:</S.BoldText>
          <S.Text>The remaining amount after deducting the above. The balance can be refunded or converted to value-based credit (choose one).</S.Text>
        </S.IndentBlock>
        <S.Text style={{ marginTop: '0.5rem', fontStyle: 'italic', color: '#666' }}>Note: If the balance after full-price calculation is zero or negative, no refund or credit is issued.</S.Text>
      </S.SubSection>

      <S.SubSection>
        <S.SubSectionTitle>3) Exceptions & Consumer Law</S.SubSectionTitle>
        <S.Text>This policy does not exclude rights under Australian Consumer Law (including remedies for major failures).</S.Text>
        <S.Text>In special circumstances (e.g., serious illness, family emergency), the centre may consider case-by-case arrangements upon provision of supporting documentation.</S.Text>
      </S.SubSection>
    </S.Section>

    {/* Appendix */}
    <S.Section>
      <S.SectionTitle>Appendix: Worked Examples (for reference only)</S.SectionTitle>
      <S.ExampleBox>
        <S.ExampleTitle>Example 1: Withdrawal refund</S.ExampleTitle>
        <p>Term package paid AU$722 (discounted), withdraw after 6 lessons. Standard casual rate AU$76.</p>
        <p>Balance = 722 - (6&times;76) - admin fee 76 = <strong>AU$190</strong> (refund or credit).</p>
      </S.ExampleBox>
      <S.ExampleBox>
        <S.ExampleTitle>Example 2: Absence credit</S.ExampleTitle>
        <p>Miss 1 lesson with 24h notice and choose credit. Term package paid AU$722 (discounted). Standard casual rate AU$76.</p>
        <p>Credit = 722 - (9&times;76) = <strong>AU$38</strong> (value-based).</p>
      </S.ExampleBox>
    </S.Section>
  </>
);

export default Policy;
